/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon16Regular = forwardRef('NetCloudWireIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.375 1a4.376 4.376 0 0 0-4.27 3.422A3.876 3.876 0 0 0 4.25 12h3v2.25h-4.5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5h-4.5V12h2.5a4.5 4.5 0 0 0-.2-9 4.371 4.371 0 0 0-3.675-2ZM4.512 5.106a2.875 2.875 0 0 1 5.447-.994.75.75 0 0 0 .77.414 3 3 0 1 1 .465 5.974H4.25a2.375 2.375 0 0 1-.37-4.722.75.75 0 0 0 .632-.672Z" })));
});
